import React, { useState } from 'react';

export function checkAdminAuth() {
  return sessionStorage.getItem('admin_logged_in') === 'true' && !!sessionStorage.getItem('admin_token');
}

const BASE = (process.env.REACT_APP_API_URL || '') + '/api';

export default function AdminLogin({ onLogin }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [changing, setChanging] = useState(false);
  const [currentPass, setCurrentPass] = useState('');
  const [newPass, setNewPass] = useState('');
  const [newPass2, setNewPass2] = useState('');
  const [changeMsg, setChangeMsg] = useState('');

  const handleLogin = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${BASE}/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password }),
      });
      if (res.ok) {
        const { token } = await res.json();
        sessionStorage.setItem('admin_token', token);
        sessionStorage.setItem('admin_logged_in', 'true');
        onLogin();
      } else {
        setError('סיסמה שגויה');
      }
    } catch {
      setError('שגיאה בהתחברות');
    } finally {
      setLoading(false);
    }
  };

  const handleChangePassword = async () => {
    if (!newPass || newPass.length < 4) { setChangeMsg('הסיסמה החדשה חייבת להכיל לפחות 4 תווים'); return; }
    if (newPass !== newPass2) { setChangeMsg('הסיסמאות החדשות לא תואמות'); return; }
    setLoading(true);
    try {
      // First verify current password
      const loginRes = await fetch(`${BASE}/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password: currentPass }),
      });
      if (!loginRes.ok) { setChangeMsg('הסיסמה הנוכחית שגויה'); setLoading(false); return; }
      const { token } = await loginRes.json();

      // Save new password
      await fetch(`${BASE}/settings`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'x-admin-token': token },
        body: JSON.stringify({ key: 'admin_password', value: newPass }),
      });
      setChangeMsg('✅ הסיסמה שונתה בהצלחה!');
      setNewPass(''); setNewPass2(''); setCurrentPass('');
      setTimeout(() => { setChanging(false); setChangeMsg(''); }, 1500);
    } catch {
      setChangeMsg('שגיאה בשמירה');
    } finally {
      setLoading(false);
    }
  };

  if (changing) return (
    <div className="login-wrap">
      <div className="login-box">
        <h2>🔑 שינוי סיסמה</h2>
        <p>הזיני את הסיסמה הנוכחית והחדשה</p>
        <div className="form-group">
          <label className="form-label">סיסמה נוכחית</label>
          <input className="form-input" type="password" value={currentPass} onChange={e => setCurrentPass(e.target.value)} placeholder="הסיסמה הנוכחית" />
        </div>
        <div className="form-group">
          <label className="form-label">סיסמה חדשה</label>
          <input className="form-input" type="password" value={newPass} onChange={e => setNewPass(e.target.value)} placeholder="לפחות 4 תווים" />
        </div>
        <div className="form-group">
          <label className="form-label">אימות סיסמה חדשה</label>
          <input className="form-input" type="password" value={newPass2} onChange={e => setNewPass2(e.target.value)} placeholder="חזרי על הסיסמה החדשה" />
        </div>
        {changeMsg && <p style={{ color: changeMsg.startsWith('✅') ? 'var(--green)' : 'var(--red)', fontSize: 14, marginBottom: 10 }}>{changeMsg}</p>}
        <div style={{ display: 'flex', gap: 10 }}>
          <button className="btn btn-cancel" style={{ flex: 1 }} onClick={() => setChanging(false)}>ביטול</button>
          <button className="btn btn-primary" style={{ flex: 1 }} onClick={handleChangePassword} disabled={loading}>{loading ? '...' : 'שמור'}</button>
        </div>
      </div>
    </div>
  );

  return (
    <div className="login-wrap">
      <div className="login-box">
        <div style={{ fontSize: 48, marginBottom: 12 }}>🔐</div>
        <h2>ממשק ניהול</h2>
        <p>הזיני סיסמה כדי להיכנס</p>
        <div className="form-group" style={{ textAlign: 'right' }}>
          <label className="form-label">סיסמה</label>
          <input className="form-input" type="password" value={password}
            onChange={e => { setPassword(e.target.value); setError(''); }}
            onKeyDown={e => e.key === 'Enter' && handleLogin()}
            placeholder="הזיני סיסמה" />
          {error && <p className="login-error">{error}</p>}
        </div>
        <button className="btn btn-primary" style={{ width: '100%', padding: 12, fontSize: 16, marginBottom: 12 }} onClick={handleLogin} disabled={loading}>
          {loading ? 'מתחבר...' : 'כניסה'}
        </button>
        <button style={{ background: 'none', border: 'none', color: 'var(--text-light)', fontSize: 13, cursor: 'pointer', textDecoration: 'underline' }}
          onClick={() => setChanging(true)}>
          שינוי סיסמה
        </button>
      </div>
    </div>
  );
}
